<template>
  <div v-outside-click="{ handler: clickOutside, include: include }" class="kk-subnav__options">
    <div class="kk-subnav__options-title" @click="showOptions = !showOptions">
      <span>{{ options[selectedOptionIndex].title }}</span>
      <span class="kk-subnav__options-icon icon-chevron-down"></span>
    </div>
    <div v-if="showOptions" class="kk-subnav__options-list">
      <div
        v-for="(item, index) in options"
        :key="index"
        class="kk-subnav__options-list-item"
        :class="{ 'kk-subnav__options-list-item-selected': item.title === options[selectedOptionIndex].title }"
        @click="selectItem(index)"
      >
        <span> {{ item.title }}</span>
        <span> {{ item.shortcut }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showOptions: false,
      selectedOptionIndex: 0,
      options: [
        { title: "A-Z", shortcut: "a" },
        { title: "changed", shortcut: "c" },
        { title: "opened", shortcut: "o" },
        { title: "new created", shortcut: "n" },
      ],
    };
  },
  methods: {
    include() {
      return [document.querySelector(".kk-subnav__options")];
    },
    selectItem(index) {
      this.selectedOptionIndex = index;
      this.showOptions = false;
    },
    clickOutside() {
      this.showOptions = false;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/styles/variables";
.kk-subnav__options {
  position: relative;
  width: 95px;
  &-icon {
    font-size: 18px;
  }
  &-title {
    font-size: 12px;
    height: 100%;
    display: flex;
    gap: 0.4rem;
    justify-content: right;
    align-items: center;
    cursor: pointer;
    color: rgb(145, 174, 231);
    &:hover {
      color: @kk-color-light-blue;
    }
  }
  &-list {
    position: absolute;
    z-index: 300;
    bottom: 0;
    left: 0;
    transform: translate(-40%, 105%);
    background: #fff;
    width: 200px;
    box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.24);
    border-radius: 4px;
    overflow: hidden;
    &-item {
      padding: 0.4rem;
      font-size: 14px;
      color: #555;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;
      border-bottom: 2px solid rgba(242, 242, 242, 1);
      & span {
        padding: 0 15px;
      }
      &:hover:not(&-selected) {
        background-color: @kk-color-light-blue;
      }
      &-selected {
        background-color: @kk-color-primary-blue;
        color: #fff;
      }
    }
  }
}
</style>
